import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanPercent',
})
export class CleanPercentPipe implements PipeTransform {
  transform(value: number): string {
    if (value == null || isNaN(value)) {
      return '';
    }
    const percentage = value;

    if (percentage % 1 === 0) {
      return percentage.toFixed(0) + '%'; 
    } else {
      return percentage.toFixed(1) + '%';
    }
  }
}
